"use client";

import { useEffect, useState } from 'react';
import { fetchHomeContent } from '../../services/homeContentApi';

const galleryItems = [
  {
    src: "/images/gallery/gallery_8.jpeg",
    alt: "Gallery 1",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_5.jpeg",
    alt: "Gallery 2",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_11.jpeg",
    alt: "Gallery 3",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_9.jpeg",
    alt: "Gallery 4",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_1.jpeg",
    alt: "Gallery 5",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_19.jpeg",
    alt: "Gallery 6",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_15.jpeg",
    alt: "Gallery 7",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  {
    src: "/images/gallery/gallery_12.jpeg",
    alt: "Gallery 9",
    title: "Dream Makers Event Planning",
    subtitle: "Gala Affairs",
    href: "/gallery-details",
  },
  
];

export default function GalleryOne() {
  const [items, setItems] = useState(galleryItems);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const content = await fetchHomeContent();
        const remote = Array.isArray(content?.gallery) ? content.gallery : [];
        if (!cancelled && remote.length > 0) {
          setItems(
            remote.map((g, idx) => ({
              src: g.image,
              alt: g.alt || `Gallery ${idx + 1}`,
              title: g.title || '',
              subtitle: g.subtitle || '',
              href: g.href || '/gallery-details',
            })),
          );
        }
      } catch {
        // keep fallback
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);


  return (
    <section className="gallery-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Notre Galerie</span>
          </div>
          <h2 className="section-title__title section-title__title--two">
            MBOAPASS, au coeur de vos évènements
          </h2>
        </div>
        <div className="gallery-masonry">
          {items.map((item, index) => (
            <div key={index} className="gallery-item">
              <div className="gallery-card">
                <img src={item.src} alt={item.alt} />
                {/* <div className="overlay">
                  <span className="subtitle">{item.subtitle}</span>
                  <h4>
                    <Link to={item.href}>{item.title}</Link>
                  </h4>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
